import { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Brightness2Icon from '@mui/icons-material/Brightness2';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { ThemeContext } from "../../contexts/theme";
import { projects, skills, contact, about } from "../../portfolio";
import "./Navbar.css";

const Navbar = () => {
  const [{ themeName, toggleTheme }] = useContext(ThemeContext);
  const [showNavList, setShowNavList] = useState(false);
  const location = useLocation();

  const toggleNavList = () => setShowNavList(!showNavList);

  const isOnHomePage = location.pathname === "/" || location.pathname === "";

  return (
    <nav className="center nav">
      <ul
        style={{ display: showNavList ? "flex" : null }}
        className="nav__list"
      >
        {projects.length ? (
          <li className="nav__list-item">
            {isOnHomePage ? (
              <a
                href="#projects"
                onClick={toggleNavList}
                className="link link--nav"
              >
                Projects
              </a>
            ) : (
              <Link
                to="/#projects"
                onClick={toggleNavList}
                className="link link--nav"
              >
                Projects
              </Link>
            )}
          </li>
        ) : null}

        {skills.length ? (
          <li className="nav__list-item">
            {isOnHomePage ? (
              <a
                href="#skills"
                onClick={toggleNavList}
                className="link link--nav"
              >
                Skills
              </a>
            ) : (
              <Link
                to="/#skills"
                onClick={toggleNavList}
                className="link link--nav"
              >
                Skills
              </Link>
            )}
          </li>
        ) : null}

        {about.resume ? (
          <li className="nav__list-item">
            <Link
              to="/resume"
              onClick={toggleNavList}
              className="link link--nav"
            >
              Resume
            </Link>
          </li>
        ) : null}

        {contact.email ? (
          <li className="nav__list-item">
            {isOnHomePage ? (
              <a
                href="#contact"
                onClick={toggleNavList}
                className="link link--nav"
              >
                Contact
              </a>
            ) : (
              <Link
                to="/#contact"
                onClick={toggleNavList}
                className="link link--nav"
              >
                Contact
              </Link>
            )}
          </li>
        ) : null}
      </ul>

      <button
        type="button"
        onClick={toggleTheme}
        className="btn btn--icon nav__theme"
        aria-label="toggle theme"
      >
        {themeName === "dark" ? <WbSunnyIcon /> : <Brightness2Icon />}
      </button>

      <button
        type="button"
        onClick={toggleNavList}
        className="btn btn--icon nav__hanburger"
        aria-label="toggle navigation"
      >
        {showNavList ? <CloseIcon /> : <MenuIcon />}
      </button>
    </nav>
  );
};

export default Navbar;
